module.exports = __webpack_public_path__ + "img/settings2.8a6cbaad.png";